import { Carousel, Image } from "@lululemon/ui-library";
import { useQVMContext } from "./hooks";
import styles from "./carousel-renderer.module.scss";

/**
 * This component renders the Carousel composition
 * passes to it the necessary data to be rendered.
 * @returns
 */
const CarouselRenderer = () => {
  const {
    activeSlide = 0,
    handleSlideChange,
    isMobile,
    productSummary,
    selectedVariant = {},
  } = useQVMContext();
  const { images = [] } = selectedVariant?.imageSet || {};
  const productTitle = productSummary?.title || productSummary?.displayName;
  return (
    <div className={`${styles.carouselWrapper} ${styles.carouselContainer}`}>
      <Carousel
        infinite
        showArrows={!isMobile}
        showPagination={isMobile}
        slideIndex={activeSlide}
        onSlideIndexChange={handleSlideChange}
      >
        {images?.map((image, key) => {
          const productImageAlt = `${
            selectedVariant?.color?.name
          } ${productTitle?.replace("*", "")}`;
          return (
            <Image
              className={styles.image}
              draggable={false}
              key={key}
              src={image.url}
              alt={productImageAlt}
              aria-label={productImageAlt}
              lazy={key > 0}
            />
          );
        })}
      </Carousel>
    </div>
  );
};

export default CarouselRenderer;
